import { Component, Input } from '@angular/core';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { StockCountPacking } from 'app/core/store/stock-count/stock-count.interface';

@Component({
  selector: 'app-stock-count-order-items',
  templateUrl: './stock-count-order-items.component.html',
  styleUrls: ['./stock-count-order-items.component.scss'],
})
export class StockCountOrderItemsComponent {
  @Input() materials: StockCountPacking[];
  @Input() definitions: Definitions;

  findPackingId(id: string): string {
    if (id && this.definitions) {
      const packing = this.definitions.packing.type.find(packing => packing.id === id);
      return packing && packing.name ? packing.name : '';
    } else {
      return '';
    }
  }
}
